import { render, staticRenderFns } from "./verify-account-banner.vue?vue&type=template&id=d8428732&scoped=true&"
import script from "./verify-account-banner.vue?vue&type=script&lang=ts&"
export * from "./verify-account-banner.vue?vue&type=script&lang=ts&"
import style0 from "./verify-account-banner.vue?vue&type=style&index=0&id=d8428732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8428732",
  null
  
)

export default component.exports